import PRODUCT_TYPE from "../const/products";
var isSecuredInstallment = function (accountType) {
    return accountType === PRODUCT_TYPE.INSTALLMENT_LOAN_SECURED;
};
export default isSecuredInstallment;
//# sourceMappingURL=isSecuredInstallment.js.map